<mat-card>
    <mat-card-header>
        <mat-card-title>Lista pagamenti</mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <div *ngIf="isBusy()" class="spinner__loading">
        <mat-progress-spinner  diameter="60" [value]="spinnervalue" mode="indeterminate">
        </mat-progress-spinner>
      </div>

      <mat-form-field style="width: 100%">
        <input
          matInput
          placeholder="Aziende"
          aria-label="Aziende"
          [matAutocomplete]="auto"
          (keyup)="onFiltroAziendaKeyup($event)"
          [(ngModel)]="selectedValueAzienda"
          required
          [readonly]="pagamento!=undefined && pagamento.Id!=0"
        />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected) ="selectedAziendaOption($event)">
          <mat-option
            *ngFor="let azienda of aziendefiltrate | async"
            [value]="azienda.Nome"
            [disabled]="pagamento!=undefined && pagamento.Id!=0">
            <span>{{ azienda.Nome }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <table class="summarycontent">
        <tr>
          <td class="summarycell" style="font-weight: bold">
            Importo dovuto
          </td>
          <td class="summarycell" style="font-weight: bold">
            IVA dovuta
          </td>
          <td class="summarycell" style="font-weight: bold">
            Importo pagato
          </td>
<!--          <td class="summarycell" style="font-weight: bold">
            IVA pagata
          </td>
-->          <td class="summarycell" style="font-weight: bold">
            Saldo
          </td>
        </tr>
        <tr>
          <td class="summarycell">
            {{importodovutototale}}
          </td>
          <td class="summarycell">
            {{ivadovutatotale}}
          </td>
          <td class="summarycell">
            {{importopagatototale}}
          </td>
  <!--        <td class="summarycell">
            {{ivapagatatotale}}
          </td>
-->          <td class="summarycell">
            {{saldototale}}
          </td>
        </tr>
      </table>


      <mat-form-field appearance="fill" style="padding-right: 10px; width:400px">
        <mat-label class="text-sm">Commessa - Targa - Telaio</mat-label>
        <mat-select [(ngModel)]="selectedValueCommessa" name="commessa" (selectionChange)="manageChangeCommessa()" class="text-sm">
          <mat-option *ngFor="let commessa of commesse" [value]="commessa.Codice">
            {{commessa.Codice}} - {{commessa.Targaveicolo}} - {{commessa.Telaioveicolo}}
          </mat-option>
        </mat-select>
      </mat-form-field>


<!--
      <mat-form-field appearance="fill" style="padding-right:10px">
        <mat-label class="text-sm">Targa</mat-label>
        <mat-select [(ngModel)]="selectedValueTarga" name="selectedValueTarga" class="text-sm" (selectionChange)="manageChangeTarga()">
          <mat-option *ngFor="let targa of targhe" [value]="targa">
            {{targa}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" style="padding-right:10px">
        <mat-label class="text-sm">Telaio</mat-label>
        <mat-select [(ngModel)]="selectedValueTelaio" name="selectedValueTelaio" class="text-sm" (selectionChange)="manageChangeTelaio()">
          <mat-option *ngFor="let telaio of telai" [value]="telaio">
            {{telaio}}
          </mat-option>
        </mat-select>
      </mat-form-field>
-->


      <mat-form-field appearance="fill" style="padding-right: 10px">
        <mat-label class="text-sm">Tipo pagamento</mat-label>
        <mat-select [(ngModel)]="selectedValueTipopagamento" name="tipopagamento" (selectionChange)="manageChangeTipopagamento()" class="text-sm">
          <mat-option *ngFor="let tipopagamento of tipipagamento" [value]="tipopagamento.Id">
            {{tipopagamento.Nome}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" style="padding-right: 10px">
        <mat-label class="text-sm">Metodo pagamento</mat-label>
        <mat-select [(ngModel)]="selectedValueMetodopagamento" name="metodopagamento" (selectionChange)="manageChangeMetodopagamento()" class="text-sm">
          <mat-option *ngFor="let metodopagamento of metodipagamento" [value]="metodopagamento.Id">
            {{metodopagamento.Nome}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" style="padding-right:10px">
        <mat-label class="text-sm">Documento fiscale</mat-label>
        <mat-select [(ngModel)]="selectedValueDocfiscale" name="selectedValueDocfiscale" (selectionChange)="manageChangeDocfiscale()" class="text-sm">
          <mat-option *ngFor="let docfiscale of docfiscali" [value]="docfiscale">
            {{docfiscale}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="summarycontent">
            <table>
              <tr>
                <td class="summarycell" style="font-weight: bold">
                  Importo dovuto commessa
                </td>
      <!--          <td class="summarycell">
                  IVA dovuta commessa
                </td>
    -->            <td class="summarycell" style="font-weight: bold">
                  Importo pagato commessa
                </td>
      <!--          <td class="summarycell">
                  IVA pagata commessa
                </td>
      -->          <td class="summarycell" style="font-weight: bold">
                  Saldo commessa
                </td>
              </tr>
              <tr>
                <td class="summarycell">
                  {{importodovutocommessa | number:'1.2-2'}}
                </td>
      <!--          <td class="summarycell">
                  {{ivadovutacommessa}}
                </td>
    -->            <td class="summarycell">
                  {{importopagatocommessa}}
                </td>
    <!--            <td class="summarycell">
                  {{ivapagatacommessa}}
                </td>
    -->            <td class="summarycell">
                  {{saldocommessa}}
                </td>
              </tr>
            </table>
      </div>


  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="Id">
          <th [style.display]="isHidden()" mat-header-cell *matHeaderCellDef> Id
          </th>
          <td [style.display]="isHidden()" mat-cell *matCellDef="let pagamento"> {{pagamento.Id}} </td>
      </ng-container>

      <ng-container matColumnDef="Datapagamento">
          <th mat-header-cell *matHeaderCellDef> Data pagamento
            <img src="./assets/images/sort.png" (click)="manageClick('Datapagamento')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Datapagamento | date:'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="Importo">
          <th mat-header-cell *matHeaderCellDef> Importo
            <img src="./assets/images/sort.png" (click)="manageClick('Importo')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Importo}} </td>
      </ng-container>

      <ng-container matColumnDef="Azienda">
          <th mat-header-cell *matHeaderCellDef> Azienda
            <img src="./assets/images/sort.png" (click)="manageClick('Azienda')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Azienda.Nome}} </td>
      </ng-container>

      <ng-container matColumnDef="Commessa">
          <th mat-header-cell *matHeaderCellDef> Commessa
            <img src="./assets/images/sort.png" (click)="manageClick('Commessa')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Commessa.Codice}} </td>
      </ng-container>

      <ng-container matColumnDef="Tipopagamento">
          <th mat-header-cell *matHeaderCellDef> Tipo pagamento
            <img src="./assets/images/sort.png" (click)="manageClick('Tipopagamento')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Tipopagamento.Nome}} </td>
      </ng-container>

      <ng-container matColumnDef="Metodopagamento">
          <th mat-header-cell *matHeaderCellDef> Metodo pagamento
            <img src="./assets/images/sort.png" (click)="manageClick('Metodopagamento')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Metodopagamento.Nome}} </td>
      </ng-container>

      <ng-container matColumnDef="Note">
          <th mat-header-cell *matHeaderCellDef> Note
            <img src="./assets/images/sort.png" (click)="manageClick('Note')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Note}} </td>
      </ng-container>

      <ng-container matColumnDef="Docfiscale">
          <th mat-header-cell *matHeaderCellDef> Doc. fiscale
            <img src="./assets/images/sort.png" (click)="manageClick('Docfiscale')"/>
          </th>
          <td mat-cell *matCellDef="let pagamento"> {{pagamento.Docfiscale}} </td>
      </ng-container>

      <ng-container matColumnDef="edit">
          <th [style.display]="isHidden()" mat-header-cell *matHeaderCellDef> Modifica </th>
          <td [style.display]="isHidden()" mat-cell *matCellDef="let azienda">
            <mat-icon color="primary" (click)="edit(pagamento)">create</mat-icon>
          </td>
      </ng-container>





      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

<!-- </form> -->
</mat-card-content>
<mat-card-actions>
  <table>
    <tr>
      <td>
        <button mat-raised-button  color="primary" (click)="new()" [disabled]="selectedValueAzienda===undefined || selectedValueAzienda==='' || selectedValueCommessa===undefined || selectedValueCommessa===0">Nuovo pagamento</button>
      </td>
      <td>
        <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
      </td>
      <td>
        <button mat-raised-button  color="primary" (click)="export()">Esporta</button>
      </td>
    </tr>
  </table>
</mat-card-actions>

</mat-card>
